/*
 * @Author: cc
 * @LastEditTime: 2022-06-15 11:40:56
 */
import { useEffect, useState } from "react";
import {
  Table,
  Space,
  Pagination,
  Modal,
  Input,
  Button,
  message,
  Tooltip,
} from "antd";
import { post } from "../../../common/fetch";
import { connect } from "react-redux";
const { TextArea } = Input;
interface NoteListProps {
  id: number;
  userId: number;
  instituteId: string;
  type: number;
  projectId: number;
  courseId: number;
  sectionId: number;
  content: string;
  sourceSystem: number;
  projectName: string;
  courseName: string;
  sectionName: string;
  updateTime: string;
}
function Notes(props: any) {
  const {
    projectType: { type },
  } = props;
  const [totalSize, setTotalSize] = useState(1);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [content, setContent] = useState("");
  const [id, setId] = useState(0);
  const [page, setPage] = useState(1);
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const onChange = ({ target: { value } }: any) => {
    setContent(value);
  };
  const columns = [
    {
      title: "序号",
      dataIndex: "key",
      key: "key",
      width: "60px",
    },
    {
      title: "课程名称",
      dataIndex: "courseName",
      key: "courseName",
    },
    {
      title: "笔记内容",
      dataIndex: "content",
      key: "content",
      width: "300",
      render: (text: string) => (
        // <div>{text.substring(0, 16)}</div>
        <Tooltip overlayClassName="overlay" title={text}>
          {text.substring(0, 16)}
        </Tooltip>
      ),
    },
    {
      title: "笔记时间",
      dataIndex: "updateTime",
      key: "updateTime",
    },
    {
      title: "操作",
      key: "action",
      render: (text: string, record: NoteListProps) => (
        <Space size="middle">
          <a
            style={{ color: "#1890ff" }}
            onClick={() => {
              showModal();
              setContent(record.content);
              setId(record.id);
            }}
          >
            编辑
          </a>
        </Space>
      ),
    },
  ];
  const [trainList, setTrainList] = useState<NoteListProps[]>([]);
  const getUserCourseWatchRecord = (page: number) => {
    post(
      `/shop/front/user/getUserLearnNoteInfo`,
      {
        currentPage: page,
        pageSize: 6,
      },
      true
    ).then((res) => {
      const { userLearnNoteList, page } = res.data;
      const { totalResultSize } = page;
      const list = userLearnNoteList.map(
        (item: NoteListProps, index: number) => {
          return {
            key: (page.currentPage - 1) * page.pageSize + (index + 1),
            ...item,
          };
        }
      );
      setTrainList(list);
      setTotalSize(totalResultSize);
    });
  };
  const upDateNotes = () => {
    if (content) {
      if (content.length > 1000) {
        message.info("笔记最多为1000字");
        return;
      }
      const url = `/shop/front/updateUserLearnNote`;
      post(
        url,
        {
          id,
          content,
        },
        true
      ).then((res) => {
        message.success("修改成功");
        setIsModalVisible(false);
        getUserCourseWatchRecord(page);
      });
    } else {
      message.info("笔记不能为空");
    }
  };
  useEffect(() => {
    getUserCourseWatchRecord(1);
  }, []);
  return (
    <div>
      <Table
        columns={columns}
        dataSource={trainList}
        pagination={false}
      ></Table>
      <div style={{ textAlign: "right", padding: "20px 0" }}>
        <Pagination
          total={totalSize}
          current={page}
          hideOnSinglePage={true}
          defaultPageSize={6}
          showSizeChanger={false}
          onChange={(page) => {
            getUserCourseWatchRecord(page);
            setPage(page);
          }}
        />
      </div>
      <Modal
        title="笔记"
        footer={null}
        closable={true}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <TextArea
          value={content}
          placeholder=""
          onChange={onChange}
          autoSize={true}
          showCount
          maxLength={1000}
          style={{ height: 300 }}
          className="notes_modal"
        />
        <div style={{ textAlign: "right", padding: "40px 0 20px" }}>
          <Button type="primary" onClick={upDateNotes}>
            修改
          </Button>
        </div>
      </Modal>
    </div>
  );
}
const getProjectType = (state: {
  projectType: { type: number; activityId?: string };
}) => {
  return {
    projectType: state.projectType,
  };
};
export default connect(getProjectType)(Notes);
